import { useTranslation } from 'react-i18next';
import { RichEditorField, RichEditorFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export const AdditionalRequirementField = <T extends string = keyof typeof MarketplaceFormKeys>({
  name,
  ...restProps
}: Partial<RichEditorFieldProps<T>>) => {
  const { t } = useTranslation();

  return (
    <RichEditorField<T>
      title={t('TextForm.Additional Requirement')}
      name={name || (MarketplaceFormKeys.additionalRequirement as T)}
      placeholder={t<string>('TextForm.AdditionalRequirementPlaceholder')}
      {...restProps}
    />
  );
};
